import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import DoctorCard from '../components/DoctorCard';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Favorites = () => {
  const { isAuthenticated } = useAuth();
  const { t } = useLanguage();
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/favorites`, { withCredentials: true });
        setDoctors(response.data || []);
      } catch (error) {
        console.error('Error fetching favorites:', error);
      } finally {
        setLoading(false);
      }
    };
    if (isAuthenticated) fetchFavorites();
    else setLoading(false);
  }, [isAuthenticated]);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="favorites-page">
        <div className="mb-8">
          <h1 className="text-2xl md:text-3xl font-bold text-[#0F172A]">
            {t('fav_title')}
          </h1>
          <p className="text-[#64748B] mt-2">{t('fav_subtitle')}</p>
        </div>

        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map(i => (
              <div key={i} className="bg-white rounded-2xl border border-[#E2E8F0] p-6 animate-pulse">
                <div className="flex gap-4">
                  <div className="w-20 h-20 rounded-xl bg-gray-200" />
                  <div className="flex-1 space-y-3">
                    <div className="h-5 bg-gray-200 rounded w-3/4" />
                    <div className="h-4 bg-gray-200 rounded w-1/2" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : !isAuthenticated ? (
          <div className="text-center py-16">
            <Heart className="w-16 h-16 text-[#E2E8F0] mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-[#0F172A] mb-2">{t('fav_login')}</h3>
            <p className="text-[#64748B]">{t('fav_login_desc')}</p>
          </div>
        ) : doctors.length === 0 ? (
          <div className="text-center py-16">
            <Heart className="w-16 h-16 text-[#E2E8F0] mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-[#0F172A] mb-2">{t('fav_empty')}</h3>
            <p className="text-[#64748B]">{t('fav_empty_desc')}</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {doctors.map(doctor => (
              <DoctorCard key={doctor.doctor_id} doctor={doctor} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Favorites;
